export const ADMIN_PRICING_FETCH = 'ADMIN_PRICING_FETCH';
export const ADMIN_PRICING_FETCH_SUCCESS = 'ADMIN_PRICING_FETCH_SUCCESS';
export const ADMIN_PRICING_FETCH_FAIL = 'ADMIN_PRICING_FETCH_FAIL';
export const ADMIN_PRICING_UPLOAD = 'ADMIN_PRICING_UPLOAD';
export const ADMIN_PRICING_UPLOAD_SUCCESS = 'ADMIN_PRICING_UPLOAD_SUCCESS';
export const ADMIN_PRICING_UPLOAD_FAIL = 'ADMIN_PRICING_UPLOAD_FAIL';
export const ADMIN_PRICING_DELETE = 'ADMIN_PRICING_DELETE';
export const ADMIN_PRICING_DELETE_SUCCESS = 'ADMIN_PRICING_DELETE_SUCCESS';
export const ADMIN_PRICING_DELETE_FAIL = 'ADMIN_PRICING_DELETE_FAIL';
export const ADMIN_PRICING_SET_SORT = 'ADMIN_PRICING_SET_SORT';
